import React, { useState , useEffect} from "react";
import SeeImg from "../../images/see.svg";
import BottonToggle from "../bars/BottomToggle";
import { Link, useNavigate } from "react-router-dom";
import Logoheader from "../../components/Logoheader";
import "./profile.css";
import TicketSvg from "../../images/tickets.svg";
import RedirectCommonModal from "../../components/alert/RedirectCommonModal";
import { useDispatch, useSelector } from "react-redux";
import { setAppUserId, setAppUserName, setEventRedirect } from "../../slices/LayoutSlice";
import { removePhoneAndMobileno, setLoggedMobileNo } from "../../utils/util";
import LogOutAlert from "../../components/alert/LogOutAlert";
import SuccessModal from "../../components/alert/SuccessModal";
import { ProfilePageView } from "../../utils/Analytics";
function Myprofile() {
  const [seeDetail, setDetail] = useState(false);
  const [isLogOutModalVisible, setIsLogOutModalVisible] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const phone_no = localStorage.getItem("phone_no");
  const email = localStorage.getItem("guest_email");
  const guestName = localStorage.getItem("appUserName");
  const appUserNameFromStore = useSelector((store) => store.layout.appUserName);
  const [checkBanner,setcheckBanner] = useState(true);

  const [isLoggedIN, setIsLoggedIN] = useState(false);
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("checkout");
    localStorage.removeItem("guest_email");
    localStorage.removeItem("phone_no");
    localStorage.removeItem("appUserName");
    localStorage.removeItem("restrictHotelListFlag");
    localStorage.removeItem("restrictHomePageFlag");
    localStorage.removeItem("RestrictWalkThroughInBottomToggle");
    localStorage.removeItem("RestrictWalkThroughInHistory");
    localStorage.removeItem("appUserId");
    localStorage.removeItem("request_room_no");
    localStorage.removeItem("request_phone_no");
    localStorage.removeItem("BookingIDDetailsArray");
    setLoggedMobileNo('');
    dispatch(setAppUserId(null));
    dispatch(setAppUserName(""));
    dispatch(setEventRedirect(''));
    setIsLogOutModalVisible(false); 
    setIsSuccessModalOpen(true);
    // setTimeout(() => {
      // setIsSuccessModalOpen(false);
      // navigate("../login");
  // }, 5000);
  };
  
  const logOutmodal = () => {
    setIsLogOutModalVisible(true); 
  };

  const closeModal = () => {
    setIsLogOutModalVisible(false); // Close the modal
};
const handleCloseSuccessModal = () => {
  console.log("logout success Modal")
  navigate("../login");
  setIsSuccessModalOpen(false);
};
  
  const switchLoginLogout = () => {
    if (
      localStorage.getItem("phone_no") === null &&
      localStorage.getItem("guest_email") === null
    ) {
      setIsLoggedIN(false);
    } else {
      setIsLoggedIN(true);
    }
  };

  useState(() => {
    switchLoginLogout();
  }, []);

  useEffect(() => {
    const isBannerDismissed = sessionStorage.getItem('alertbannerDismissed');
    if (isBannerDismissed) {
      setcheckBanner(false);
    }
  }, []);

   useEffect(() => {
      ProfilePageView();
     }, []);

  return (
    <div className="">
      <BottonToggle logout />
      <Logoheader />

      <div className="pt-7  my-profile section-wrap pb-5 h-full min-h-[70vh] relative flex flex-col items-baseline ">
        {/* {isLoggedIN && (
          <div className="mt-10 w-full">
            <div className="flex items-center gap-3">
              {guestName && <div className="avathar">{guestName[0]}</div>}
              {guestName && <div className="name">{guestName}</div>}
            </div>

            <div className="profile-details mt-8 pb-0">
              <div className="flex items-center justify-between mb-5 pb-4">
                <div className="head">Profile Details</div>
                <button onClick={() => setDetail(!seeDetail)}>
                  <img src={SeeImg} alt="" />
                </button>
              </div>
              {seeDetail && (
                <div className="pb-4">
                  {guestName && <div className="name mb-1">{guestName}</div>}
                  <div className="email">{phone_no ? phone_no : email}</div>
                </div>
              )}
            </div>
          </div>
        )} */}
        <div className="avatar-section flex flex-col justify-center items-center w-full">
          {guestName&&<div className="avatar">{guestName[0]}</div>}
          <div className="name mt-3">{guestName}</div>
          <div className="mail mt-1">{email}</div>
          <div className="mail mt-1">{phone_no}</div>
        </div>
        <div className="history-section mt-10 w-full pb-[300px]">
          <Link to="../profile-history">
            <div className="cards w-full">
              <div className="title">Hotel Bookings</div>
              <div className="para mt-2">Your Order And Booking History</div>
            </div>
          </Link>

          <Link to={"../tickets"} className="flex mt-8 gap-3 cursor-pointer">
            <img src={TicketSvg} alt="ticket" />
            <div className="title">Tickets</div>
          </Link>
        </div>
        <div className=" fixed bottom-24 w-11/12 max-w-[500px] left-1/2 -translate-x-1/2">
          {/* <div className="bg-[green] "> */}
          {isLoggedIN ? (
            <div onClick={logOutmodal} className="logout cursor-pointer w-full ">
              Log out
            </div>
          ) : (
            <div
              onClick={() => navigate("/login")}
              className="logout cursor-pointer"
            >
              Log in
            </div>
          )}
          </div>
        {/* </div> */}
      </div>
      {isLogOutModalVisible && (
                <LogOutAlert
                    heading="Logout Confirmation"
                    para="Are you sure you want to log out?"
                    onClose={closeModal} 
                    onConfirm={handleLogout} 
                />
            )}
            {/* {isLogOutConfirm && (
               <LogOutAlert
               heading="Logout Successfully LogOut"
               onClose={closeModal} 
               onConfirm={confirmLogout} 
           />

            )} */}
           {isSuccessModalOpen && <SuccessModal
                onClose={()=>handleCloseSuccessModal()}
                message="You Have Successfully Logged Out."
                heading="Logout Successful"
            />}
      
      {!guestName && !isSuccessModalOpen && <RedirectCommonModal heading="Please Complete Your Profile" para="Login and give the details" link={appUserNameFromStore? "../hotel-list" : "../login"}/>}
    </div>
  );
}

export default Myprofile;
